export const theme = {
  colors: {
    main: "#e0e0e0",
    lightAccent: "#adc7c7",
  },
  fontFamilies: {
    arial: "Arial, Helvetica, sans-serif",
  },
  fontSizes: {
    small: "0.75rem",
    medium: "1rem",
    large: "1.5rem",
  },
  widths: {
    maxPageWidth: "900px",
  },
  mediaQueries: {},
};

export type ThemeType = typeof theme;
